/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Planyearlysavingshint3Inputs */

const en_planyearlysavingshint3 = /** @type {(inputs: Planyearlysavingshint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.percent}% less when billed yearly`)
};

const de_planyearlysavingshint3 = /** @type {(inputs: Planyearlysavingshint3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jährlich bis zu ${i?.percent} % günstiger`)
};

/**
* | output |
* | --- |
* | "Up to {percent}% less when billed yearly" |
*
* @param {Planyearlysavingshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planyearlysavingshint3 = /** @type {((inputs: Planyearlysavingshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planyearlysavingshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planyearlysavingshint3(inputs)
	return de_planyearlysavingshint3(inputs)
});
export { planyearlysavingshint3 as "planYearlySavingsHint" }